/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

/*
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

*/
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const swiper = new Swiper('.testimonials', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    autoHeight: true,

    breakpoints: {
      768: {
        spaceBetween: 40,
        autoHeight: false
      }
    },
  
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
  });

  Fancybox.bind('[data-fancybox]', {});

  
  $('.show-calculator').click(function(e) {
    e.preventDefault();
    $('.custom-calculator').addClass('visible');
    $('.calculator-overlay').addClass('visible');
  });
  
  $(document).click(function(event) {
    if (!$(event.target).closest(".custom-calculator,.show-calculator").length) {
      $("body").find(".custom-calculator").removeClass("visible");
      $("body").find(".calculator-overlay").removeClass("visible");
    }
  });

  document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.blog-item');

    buttons.forEach(button => {
      button.addEventListener('click', function(event) {

        event.preventDefault();

        buttons.forEach(btn => {
          btn.classList.remove('active');
        });

        this.classList.add('active');

        const buttonUrl = this.getAttribute('href');
        if (buttonUrl && buttonUrl !== '#') {
          setTimeout(() => {
            window.location.href = buttonUrl;
          }, 100); 
        }
      });
    });

    const currentUrl = window.location.href;
    buttons.forEach(button => {
      const buttonUrl = button.getAttribute('href');
      if (currentUrl.includes(buttonUrl)) {
        button.classList.add('active');
      }
    });
    
    const swiper = new Swiper('.article-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      navigation: {
        nextEl: '.swiper-article-button-next',
        prevEl: '.swiper-article-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
    });

    setTimeout(function() {
    const skioPlanPicker = document.querySelector('skio-plan-picker');
    const subscription_benefits = document.getElementById('subscription_benefits');
    if(skioPlanPicker && subscription_benefits) {
      const shadowRoot = skioPlanPicker.shadowRoot;
      const subscriptionEl = shadowRoot.querySelector('[skio-group-container--subscription]');
      const benefitsElement = document.createElement('div');
      benefitsElement.classList.add('subscription_benefits');
      benefitsElement.innerHTML = subscription_benefits.innerHTML;
      subscriptionEl.after(benefitsElement);
      shadowRoot.append(document.getElementById('subscription_benefits_shadow').content.cloneNode(true));

      // const most_popular = document.querySelector('.variant-badge--most-popular');
      // if(most_popular) {
      //   most_popular.querySelector('label').click();
      // }
    }
    }, 1000);

    // document.addEventListener('theme:cart:change', function(event) {
    //   var cart = event.detail.cart;
    //   if (cart) {
    //     console.log('Cart ———————————— ↓');
    //     console.log(cart);
    //   }
    // });
    const subscription_products_list = document.getElementById('subscription_products_list');
    const subscription_free_product = document.getElementById('subscription_free_product');
    document.addEventListener('rebuy:cart.ready', (event) => {
      const Cart = window.Rebuy.Cart;
      if(subscription_products_list && subscription_free_product) {
        document.addEventListener('rebuy:cart.change', (event) => { 
          var cart = event.detail.cart.cart;
          var cart_items = cart.items;
          var add_free_product = false;
          var has_free_product = false;
          for(var i = 0; i < cart_items.length; i++) {
            let cart_item = cart_items[i];
            if('selling_plan_allocation' in cart_item) {
              if(subscription_products_list.value.includes(cart_item.product_id)) {
                add_free_product = true;
              }
            }
            if(subscription_free_product.value == cart_item.id.toString()) has_free_product = true;
            
          }
          console.log("add_free_product",add_free_product,"has_free_product",has_free_product)
          if(add_free_product && !has_free_product) {
            Cart.addItem({
              id: subscription_free_product.value,
              quantity: 1
            });
          } else if(!add_free_product && has_free_product) {
            Cart.changeItem({
              id: subscription_free_product.value,
              quantity: 0
            });
          }
        });
      }
      

      const free_gift_product_trigger = document.getElementById('free_gift_product_trigger');
      const free_gift_product = document.getElementById('free_gift_product');
      if(free_gift_product_trigger && free_gift_product) {
        const free_gift_product_trigger_sku = document.getElementById('free_gift_product_trigger_sku');
        document.addEventListener('rebuy:cart.change', (event) => { 
          var cart = event.detail.cart.cart;
          var cart_items = cart.items;
          var add_free_product = false;
          var has_free_product = false;
          for(var i = 0; i < cart_items.length; i++) {
            let cart_item = cart_items[i];
            if(free_gift_product.value == cart_item.id.toString()) has_free_product = true;
            if(free_gift_product_trigger.value == cart_item.product_id.toString()) {
              if(free_gift_product_trigger_sku) {
                if(free_gift_product_trigger_sku.value == cart_item.sku) {
                  add_free_product = true;
                }
              } else {
                add_free_product = true;
              }
            }
          }
          if(add_free_product && !has_free_product) {
            Cart.addItem({
              id: free_gift_product.value,
              quantity: 1
            });
          } else if(!add_free_product && has_free_product) {
            Cart.changeItem({
              id: free_gift_product.value,
              quantity: 0
            });
          }
        });
      }
    });

  });

  
})();

